module.exports = __webpack_public_path__ + "1743c38152ac204544227f0cf674ccb0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C000016QP.png
// module id = 1656
// module chunks = 0